import './Resume.css';

export default function Resume() {
    return (
        <div className="Resume">
            <iframe title="Resume" src="https://drive.google.com/file/d/1b17fsMNWh6R3tdW_549PtbmLmQF8uEX9//preview" height="100%" width="100%"></iframe>
        </div>
    )
}

